var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.44 11.05L11.25 20.24C10.1242 21.3659 8.59723 21.9984 7.00505 21.9984C5.41286 21.9984 3.88589 21.3659 2.76005 20.24C1.6342 19.1142 1.00171 17.5872 1.00171 15.995C1.00171 14.4029 1.6342 12.8759 2.76005 11.75L11.95 2.56004C12.7006 1.80948 13.7186 1.38782 14.78 1.38782C15.8415 1.38782 16.8595 1.80948 17.61 2.56004C18.3606 3.3106 18.7823 4.32859 18.7823 5.39004C18.7823 6.4515 18.3606 7.46948 17.61 8.22004L8.41005 17.41C8.03476 17.7853 7.52577 17.9962 6.99505 17.9962C6.46432 17.9962 5.95533 17.7853 5.58005 17.41C5.20476 17.0348 4.99393 16.5258 4.99393 15.995C4.99393 15.4643 5.20476 14.9553 5.58005 14.58L14.07 6.10004",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.d3bf02a52667a656baa835ca66b3364b18181125ce8d28b5aee6dca303cfe084.svg";
export { ForwardRef as ReactComponent };